type Range = [number, number];

export interface ColorGeneratorConfig {
  saturation: Range;
  lightness: Range;
}

function hashCode(str: string): number {
  const len = str.length;
  let hash = 0;

  for (let i = 0; i < len; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
  }

  return Math.abs(hash);
}

function boundHashCode(num: number, range: Range) {
  return (num % Math.abs(range[1] - range[0])) + range[0];
}

function hslToString(h: number, s: number, l: number): string {
  return `hsl(${h}, ${s}%, ${l}%)`;
}

export function generateColorFromString(
  value: string,
  config: ColorGeneratorConfig = {
    saturation: [70, 100],
    lightness: [25, 43],
  },
): string {
  const hash = hashCode(value);

  const h = boundHashCode(hash, [0, 360]);
  const s = boundHashCode(hash, config.saturation);
  const l = boundHashCode(hash, config.lightness);

  return hslToString(h, s, l);
}
